(($) => {
  $(document).ready(() => {
    $(':file').jfilestyle({
      placeholder: 'Nenhum arquivo selecionado',
      text: 'Anexar Currículo'
    });

    $('input, textarea, select').focus(function() {
      $(this).parent().parent().addClass('focus')
    })

    $('input, textarea, select').blur(function() {
      $(this).parent().parent().removeClass('focus')
    })
  })
})(jQuery)
